import React, { useEffect, useState } from "react";

import { SearchIcon } from "../../../shared-components/icons";
import LoadingSpinner from "../../../shared-components/LoadingSpinner";
import { RecurFilterOption } from "../../../api/Person";

type Props = {
  type: "active" | "cancelled";
  companyUUID: string;
  filterList: RecurFilterOption[];
  search: string;
  selected: string[];
  loading: boolean;
  onSave: (recurUUIDs: string[], search: string) => void;
  onCancel: () => void;
  onSearch: (search: string) => void;
};

const SubscriptionsTableFilter = ({
  type,
  companyUUID,
  filterList,
  search,
  selected,
  loading,
  onSave,
  onCancel,
  onSearch,
}: Props) => {
  const [filteredList, setFilteredList] = useState<RecurFilterOption[]>([]);
  const [searchString, setSearchString] = useState<string>(search);
  const [selectedItems, setSelectedItems] = useState<string[]>(selected);

  useEffect(() => {
    if (filterList) {
      setFilteredList(filterList);
    }
  }, [filterList]);

  const clear = () => {
    setSelectedItems([]);
    setSearchString("");
    onSearch("");
    onSave([], "");
  };

  const onCheckboxChange = (
    id: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter((item) => item !== id));
    }
  };

  const save = () => {
    onSave(selectedItems, searchString);
  };

  const cancel = () => {
    onCancel();
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full relative">
        <input
          type="text"
          className="bg-white rounded-md border border-gray-300 w-full px-3 py-2 text-sm"
          value={searchString}
          onChange={(e) => {
            setSearchString(e.target.value);
            onSearch(e.target.value);
          }}
        />
        <SearchIcon className="absolute right-3 top-2"></SearchIcon>
      </div>
      {!loading && (
        <div className="rounded-lg text-zinc-600 border-solid border border-gray-400 p-3 flex flex-col gap-2 min-h-[300px] max-h-96 overflow-y-scroll">
          {filteredList.map((item, i) => (
            <div key={i} className="flex gap-1">
              <input
                type="checkbox"
                id={item.recur_uuid}
                checked={selectedItems.includes(item.recur_uuid)}
                onChange={(e) => onCheckboxChange(item.recur_uuid, e)}
              />
              <label className="mt-[1px] ml-2" htmlFor={item.recur_uuid}>
                <div className="text-sm font-bold">{item.full_name}</div>
                <div className="text-[0.5rem] text-zinc-400">
                  {item.recur_uuid}
                </div>
              </label>
            </div>
          ))}
        </div>
      )}
      {loading && (
        <div className="rounded-lg text-zinc-600 border-solid border border-gray-400 p-3 flex flex-col gap-4 min-h-[100px] max-h-36 items-center justify-center">
          <LoadingSpinner></LoadingSpinner>
        </div>
      )}
      <div className="flex justify-between gap-3">
        <button
          onClick={() => clear()}
          className="bg-white  rounded-md active:ring-ourBlue focus:ring-ourBlue focus:ring cursor-pointer text-sm focus:outline-none hover:bg-hoverBlue font-bold rounded-4xl px-6 py-2 border border-gray-300 border-solid text-zinc-600 hover:text-ourBlue"
        >
          Clear
        </button>
        <div className="flex gap-3">
          <button
            onClick={cancel}
            className="bg-white rounded-md inline-block active:ring-ourBlue focus:ring-ourBlue focus:ring cursor-pointer text-sm focus:outline-none hover:bg-hoverBlue font-bold rounded-4xl px-3 py-3 border border-gray-300 border-solid text-zinc-600 hover:text-ourBlue"
          >
            Cancel
          </button>
          <button
            onClick={save}
            disabled={selectedItems.length === 0}
            className="shadow-sm px-8 py-3 font-bold rounded-md text-base bg-ourGreen hover:bg-ourGreenHover active:bg-ourGreenDown  rounded-4xl justify-center items-center gap-2.5 flex disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <div className="text-white text-sm font-bold leading-normal">
              Ok
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionsTableFilter;
